import {isEventsInMembersInstalled} from '../../../../../../commons/selectors/installed-apps'
import {isMembersVisible, isRibbonVisible} from '../../../selectors/settings'
import {AppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/connect'
import {SideBySideItemOwnProps, SideBySideItemStateProps} from './interfaces'
import {SideBySideItem} from './side-by-side-item'

const mapRuntime = ({state}: AppProps, {event}: SideBySideItemOwnProps): SideBySideItemStateProps => {
  return {
    showMembers: isMembersVisible(state, event),
    membersEnabled: isEventsInMembersInstalled(state),
    showRibbon: isRibbonVisible(state, event),
  }
}

export default connect<SideBySideItemOwnProps, SideBySideItemStateProps>(mapRuntime)(SideBySideItem)
export * from './interfaces'
